import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  line-height: 0;
  margin-top: ${props => props.marginTop || '0'};
  margin-bottom: ${props => props.marginBottom || '0'};
  transform: ${props => props.flip ? 'rotate(180deg)' : 'none'};

  svg {
    position: relative;
    display: block;
    width: calc(100% + 1.3px);
    height: ${props => props.height || '100px'};
  }

  .shape-fill {
    fill: ${props => props.color || 'rgba(0,0,0,0.5)'};
  }
`;

const WaveDividerWidget = ({ node }) => {
  return (
    <Wrapper 
      height={node.style?.desktop?.height} 
      color={node.style?.desktop?.color}
      flip={node.style?.desktop?.flip}
      marginTop={node.style?.desktop?.marginTop}
      marginBottom={node.style?.desktop?.marginBottom}
    >
      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
      </svg>
    </Wrapper>
  );
};

registry.register('wave_divider', {
  label: 'Shape Divider',
  icon: '〰️',
  category: 'layout',
  defaultContent: {},
  defaultStyle: { desktop: { height: '80px', color: 'var(--glass-1)', flip: false } },
  render: WaveDividerWidget,
  inspectorControls: [
    { tab: 'style', groups: [{ title: 'Einstellungen', fields: [{name:'style.desktop.height', label:'Höhe', type:'text'}, {name:'style.desktop.color', label:'Füllfarbe', type:'text'}, {name:'style.desktop.flip', label:'Umdrehen (Unten)', type:'checkbox'}] }] }
  ]
});
